/**
 * Google Analytics 4 (gtag) — only after cookie consent.
 * Measurement ID from GA property Map4Nomads.
 */
export const GA_MEASUREMENT_ID = "G-81P8CYFSRW";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
    __m4nGaLoaded?: boolean;
  }
}

export function hasAnalyticsConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem("cookie_consent") === "accepted";
  } catch {
    return false;
  }
}

/** Load gtag.js once and send the first page_view. */
export function loadGoogleAnalytics(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__m4nGaLoaded) return;
  if (!hasAnalyticsConsent()) return;

  window.dataLayer = window.dataLayer || [];
  // Must use `arguments` (not a rest array) so gtag.js can process the queue
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.__m4nGaLoaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    // page_view: onRouteUpdate + explicit call below after consent
    send_page_view: false,
  });
  window.gtag("event", "page_view", {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** SPA route changes (Gatsby client navigation). */
export function trackPageView(pathname: string): void {
  if (typeof window === "undefined") return;
  if (!hasAnalyticsConsent()) return;
  if (!window.gtag) {
    loadGoogleAnalytics();
    return;
  }
  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}
